import update from 'immutability-helper';
import _ from 'lodash';

import { serviceNames, statuses } from '../../constants/project';
import { Project } from '../../types/entities';
import { PROJECTS_ACTION_NAMES } from '../actions/project';
import { Action } from '../redux.types';

const getFormattedProject = (project: any) => ({
  ...project,
  status: project.status.toLowerCase(),
  domain: project.apiHost,
  services: _(project.services)
    .map((service: any) => {
      const status = service.status.toLowerCase();

      return _.assign(service, {
        status,
        isAlive: _.includes([statuses.READY, statuses.PENDING], status),
        // TODO: use type without mapping
        name: service.type,
      });
    })
    .concat({
      name: serviceNames.file,
      host: project.filesHost,
      status: project.filesHost ? statuses.READY : statuses.PENDING,
      isAlive: true,
    })
    .value(),
});

const getProjectIndex = (members, id) => _.findIndex(members, { id });

export const projects = (state: Project[] = [], { type, payload }: Action) => {
  switch (type) {
    case PROJECTS_ACTION_NAMES.PROJECTS_SUCCESS:
      return _.map(payload, getFormattedProject);

    case PROJECTS_ACTION_NAMES.PROJECT_ADD_SUCCESS:
      return [getFormattedProject(payload), ...state];

    case PROJECTS_ACTION_NAMES.PROJECT_DELETE_SUCCESS:
      return update<any, any>(state, {
        [getProjectIndex(state, payload)]: {
          status: { $set: statuses.DELETING },
        },
      });

    case PROJECTS_ACTION_NAMES.UPDATE_PROJECT_STATUSES_SUCCESS: {
      const newProjects = payload.responsePayload;
      const oldProjectsMap = _.reduce(
        state,
        (accumulator, project: Project, index: number) => {
          accumulator[project.id] = {
            index,
            status: project.status,
          };

          return accumulator;
        },
        {},
      );

      const updatedProjects: any = _.reduce(
        newProjects,
        (accumulator: Project[], project: Project) => {
          if (project.status !== _.get(oldProjectsMap[project.id], 'status')) {
            return update<any, any>(accumulator, {
              [oldProjectsMap[project.id].index]: {
                status: { $set: project.status.toLowerCase() },
              },
            });
          }

          return accumulator;
        },
        state,
      );

      if (newProjects.length < state.length) {
        const deletedProjects = _.differenceBy(state, newProjects, 'id');

        _.forEach(deletedProjects, (project: Project) => {
          _.remove(
            updatedProjects,
            (updatedProject: Project) => updatedProject.id === project.id,
          );
        });

        return [...updatedProjects];
      }

      return updatedProjects;
    }

    default:
      return state;
  }
};
